import { useState, useRef, useContext } from 'react';
import { Box, Typography } from '@mui/material';

import { displayTeamCharge, teamChargeLabel, deliveryFeeLabel } from '../../constants/global';

import AuthContext from '../../store/auth-context';
import SalesTaxMessage from '../Widgets/SalesTaxMessage';
import Notification from '../MUI/UI/Notification';
import FormControls from '../MUI/FormControls/FormControls';
import classes from '../CSS/standard-mui-form.module.css';

const PaymentForm = ({ orderDetails }) => {
  const authCtx = useContext(AuthContext);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const userDetails = authCtx.userDetails;
  const orgDetails = authCtx.orgDetails;

  // console.log('userDetails', userDetails);
  // console.log('orderDetails', orderDetails);



  const stateOptions = [
    { id: 'AL', title: 'AL' }, { id: 'AK', title: 'AK' }, { id: 'AZ', title: 'AZ' },
    { id: 'AR', title: 'AR' }, { id: 'CA', title: 'CA' }, { id: 'CO', title: 'CO' },
    { id: 'CT', title: 'CT' }, { id: 'DE', title: 'DE' }, { id: 'DC', title: 'DC' },
    { id: 'FL', title: 'FL' }, { id: 'GA', title: 'GA' }, { id: 'HI', title: 'HI' },
    { id: 'ID', title: 'ID' }, { id: 'IL', title: 'IL' }, { id: 'IN', title: 'IN' },
    { id: 'IA', title: 'IA' }, { id: 'KS', title: 'KS' }, { id: 'KY', title: 'KY' },
    { id: 'LA', title: 'LA' }, { id: 'ME', title: 'ME' }, { id: 'MD', title: 'MD' },
    { id: 'MA', title: 'MA' }, { id: 'MI', title: 'MI' }, { id: 'MN', title: 'MN' },
    { id: 'MS', title: 'MS' }, { id: 'MO', title: 'MO' }, { id: 'MT', title: 'MT' },
    { id: 'NE', title: 'NE' }, { id: 'NV', title: 'NV' }, { id: 'NH', title: 'NH' },
    { id: 'NJ', title: 'NJ' }, { id: 'NM', title: 'NM' }, { id: 'NY', title: 'NY' },
    { id: 'NC', title: 'NC' }, { id: 'ND', title: 'ND' }, { id: 'OH', title: 'OH' },
    { id: 'OK', title: 'OK' }, { id: 'OR', title: 'OR' }, { id: 'PA', title: 'PA' },
    { id: 'RI', title: 'RI' }, { id: 'SC', title: 'SC' }, { id: 'SD', title: 'SD' },
    { id: 'TN', title: 'TN' }, { id: 'TX', title: 'TX' }, { id: 'UT', title: 'UT' },
    { id: 'VT', title: 'VT' }, { id: 'VA', title: 'VA' }, { id: 'WA', title: 'WA' },
    { id: 'WV', title: 'WV' }, { id: 'WI', title: 'WI' }, { id: 'WY', title: 'WY' }
  ];


  const nameRef = useRef();
  const address1Ref = useRef();
  const address2Ref = useRef();
  const cityRef = useRef();
  // const stateRef = useRef();
  const zipcodeRef = useRef();
  const emailRef = useRef();


  const paymentEmail = orgDetails && orgDetails.orgEmail ? orgDetails.orgEmail : userDetails.email;
  const deliveryName = orderDetails['deliveryLocation']['name'];
  const deliveryAddress1 = orderDetails['deliveryLocation']['type'] === 'Stadium' 
  ? orderDetails['deliveryLocation']['address1'] 
  : '';
  const deliveryAddress2 = orderDetails['deliveryLocation']['type'] === 'Stadium' 
  ? orderDetails['deliveryLocation']['address2'] 
  : '';
  const deliveryCity = orderDetails['deliveryLocation']['city'];
  const deliveryState = orderDetails['deliveryLocation']['state'];
  const deliveryZipcode = orderDetails['deliveryLocation']['type'] === 'Stadium' 
  ? orderDetails['deliveryLocation']['zipcode'] 
  : '';

  const [selectedDeliveryState, setSelectedDeliveryState] = useState(deliveryState);


  
  const makePayment = (event) => {
    event.preventDefault();

    const processPayment = true;
    if (!processPayment) {
      return;
    }

    const apiURL = authCtx.baseApiUrl + 'orderpayment';
    const apiMethod = 'POST';

    const enteredEmail = emailRef.current.value;
    const enteredName = nameRef.current.value;
    const enteredAddress1 = address1Ref.current.value;
    const enteredAddress2 = address2Ref.current.value;
    const enteredCity = cityRef.current.value;
    const enteredState = selectedDeliveryState;
    const enteredZipcode = zipcodeRef.current.value;
    
    // console.log('enteredEmail = ' + enteredEmail);
    // console.log('enteredName = ' + enteredName);
    // console.log('enteredAddress1 = ' + enteredAddress1);
    // console.log('enteredAddress2 = ' + enteredAddress2);
    // console.log('enteredCity = ' + enteredCity);
    // console.log('enteredState = ' + enteredState);
    // console.log('enteredZipcode = ' + enteredZipcode);



    // TEMP
    // return;

    fetch(apiURL, {
      method: apiMethod,
      body: JSON.stringify({
        user_uuid: userDetails.userUuid,
        order_uuid: orderDetails.orderUuid,
        subtotal: orderDetails.subtotal,
        email: enteredEmail,
        name: enteredName,
        address1: enteredAddress1,
        address2: enteredAddress2,
        city: enteredCity,
        state: enteredState,
        zipcode: enteredZipcode,
      }),
      headers: {
        Authorization: authCtx.token,
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      // setIsLoading(false);

      if (res.ok) {
        return res.json().then((responseData) => {
          // console.log(' ** SUCCESS ** ');
          // console.log(responseData);

          if (responseData.data.checkout_url) {
            window.location.href = responseData.data.checkout_url;
          } else {
            console.log('no checkoutUrl');
          }
        });
      } else {
        return res.json().then((responseData) => {
          // Todo: Show an Error Modal.
          // console.log(responseData);
          // setIsError(true);
          if (
            responseData &&
            Array.isArray(responseData.messages) &&
            responseData.messages.length
          ) {
            // setDisplayMessage(responseData.messages);
            console.table(responseData.messages);
            setNotify({
              isOpen: true,
              message: responseData.messages,
              type: 'error',
            });
          } else {
            // setDisplayMessage([[textFailedApiCallMessage]]);
            console.log('*** SOMETHING HAPPENED ***');
            setNotify({
              isOpen: true,
              message: 'Something Happened',
              type: 'error',
            });
          }
        });
      }
    });
  };




  const deliveryStateChangeHandler = (event) => {
    console.log('event.target.value = ' + event.target.value);

    setSelectedDeliveryState(event.target.value);
  };




  
  return (
    <Box className={classes['grid-2']}>
      <Box>
        <Typography variant='h9'>Delivery Date</Typography>
        {orderDetails['deliveryDateAndTimeForDisplay'] ? (
          <Typography variant='labelLarge'>{orderDetails['deliveryDateAndTimeForDisplay']}</Typography>
        ) : null}





{/* 
        <Typography variant='h9'>Delivery Location</Typography>

        <Typography>{orderDetails['deliveryLocation']['name']}</Typography>
        <Typography>{deliveryName}</Typography>
        <Typography>{orderDetails['deliveryLocation']['type']}</Typography>

        <Typography>{orderDetails['deliveryLocation']['address1']}</Typography>
        {orderDetails['deliveryLocation']['address2'] ? (
          <>
            <Typography>{orderDetails['deliveryLocation']['address2']}</Typography>
          </>
        ) : null}
        <Typography>{`${orderDetails['deliveryLocation']['city']}, ${orderDetails['deliveryLocation']['state']} ${orderDetails['deliveryLocation']['zipcode']}`}</Typography>


        <Typography variant='h9'>Payment Email</Typography>

        <Typography>{paymentEmail}</Typography> */}


        <Box sx={{pt: '20px'}}>
        <form onSubmit={makePayment}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '2rem',
            }}
          >

            <FormControls.InputControl
              type='email'
              name='email'
              label='Payment Email'
              inputRef={emailRef}
              defaultValue={paymentEmail}
              inputProps={{ maxLength: 50 }}
              className={classes['mui-control']}
              required
            />
  
          
            <Typography variant='h9'>Delivery Address</Typography>
            <Typography variant='caption' sx={{mt: '-20px'}}>(used to calculate tax)</Typography>

            <FormControls.InputControl
              type='text'
              name='name'
              label='Name'
              inputRef={nameRef}
              defaultValue={deliveryName}
              required
              inputProps={{ maxLength: 50 }}
              className={classes['mui-control']}
            />

            <FormControls.InputControl
              type='text'
              name='address1'
              label='Address 1'
              inputRef={address1Ref}
              defaultValue={deliveryAddress1}
              required
              inputProps={{ maxLength: 250 }}
              className={classes['mui-control']}
            />
            <FormControls.InputControl
              type='text'
              name='address2'
              label='Address 2'
              inputRef={address2Ref}
              defaultValue={deliveryAddress2}
              inputProps={{ maxLength: 250 }}
              className={classes['mui-control']}
            />

          </Box>


          <Box sx={{ pt: '20px'}}>
          <Box className={classes['grid-2']}>
            <FormControls.InputControl
              type='text'
              name='city'
              label='City'
              inputRef={cityRef}
              defaultValue={deliveryCity}
              required
              inputProps={{ maxLength: 50 }}
              className={classes['mui-control']}
            />

            <Box className={classes['grid-2']}>

              <FormControls.SelectControl
                name='state'
                label='State'
                value={selectedDeliveryState}
                onChange={deliveryStateChangeHandler}
                options={stateOptions}
                makeRequired={true}
              />

              <FormControls.InputControl
                type='text'
                name='zipcode'
                label='Zipcode'
                inputRef={zipcodeRef}
                defaultValue={deliveryZipcode}
                inputProps={{ maxLength: 7 }}
                required
                className={classes['mui-control']}
              />
            </Box>
          </Box>
          </Box>

          <Box component='div' className={classes['actions-container']} sx={{ pt: '20px' }}>
            <FormControls.ButtonControl text='Pay for Order' type='submit' color='primary' />
          </Box>

        </form>

        </Box>









      </Box>
      <Box align='right' sx={{ pt: '2rem' }}>
        <table className='table-simple table-simple-with-padding'>
          <tbody>
            <tr>
              <td className='table-td-label-np'>Subtotal (Cart Items)</td>
              <td className='table-td-number table-td-label-np'>
                {orderDetails['subtotalFormatted']}
              </td>
            </tr>

            {displayTeamCharge &&
            orderDetails['teamChargeFormatted'] &&
            orderDetails['teamCharge'] > 0 ? (
              <>
                <tr>
                  <td className='table-td-text-right'>{teamChargeLabel}</td>
                  <td className='table-td-number'>{orderDetails['teamChargeFormatted']}</td>
                </tr>
              </>
            ) : null}

            {orderDetails['deliveryFeeFormatted'] && orderDetails['deliveryFee'] !== 0 ? (
              <>
                <tr>
                  <td className='table-td-text-right'>{deliveryFeeLabel}</td>
                  <td className='table-td-number'>{orderDetails['deliveryFeeFormatted']}</td>
                </tr>
              </>
            ) : null}

            {orderDetails['tipFormatted'] && orderDetails['tip'] > 0 ? (
              <>
                <tr>
                  <td className='table-td-text-right'>Gratuity (for the driver)</td>
                  <td className='table-td-number'>{orderDetails['tipFormatted']}</td>
                </tr>
              </>
            ) : null}

            {orderDetails['calculatedTotalFormatted'] ? (
              <>
                <tr>
                  <td className='table-td-label-np with-padding'>Total</td>
                  <td className='table-td-number table-td-label-np with-padding'>
                    {orderDetails['calculatedTotalFormatted']}
                  </td>
                </tr>
              </>
            ) : null}
          </tbody>
        </table>

        <Box className='pt-20'>
          <SalesTaxMessage textAlign='right' />
        </Box>

        {/* <Box sx={{ pt: '2rem' }}>
          <Button variant='contained' onClick={() => makePayment()}>
            Pay for Order
          </Button>
        </Box> */}
      </Box>

      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
};

export default PaymentForm;
